import { useQueryParam, useRouter } from 'react-resource-router';

export const useFeedWallParams = () => {
  const [categoryId = '', setCategory] = useQueryParam('category');
  const [type = '', setType] = useQueryParam('type');
  const [sort = '', setSort] = useQueryParam('sort');
  const [status = '', setStatus] = useQueryParam('status');
  const [tag = '', setTag] = useQueryParam('tag');
  const [routerState, routerActions] = useRouter();

  const handleReset = () => {
    // Navigate to the same path without query parameters to clear all filters
    routerActions.push(routerState.location.pathname);
  };

  return {
    categoryId,
    type,
    sort,
    status,
    tag,
    setCategory,
    setType,
    setSort,
    setStatus,
    setTag,
    handleReset,
  };
};
